import HorsesPage from './HorsesPage';

export default HorsesPage;
